module.exports = "<div class=\"kan-partner-list\">\n    <!--<div class=\"kan-spinner-container\"-->\n         <!--*ngIf=\"loading\">-->\n        <!--<mat-spinner color=\"primary\"></mat-spinner>-->\n    <!--</div>-->\n    <kan-partner-list-item *ngFor=\"let partner of partners\"\n                           [partner]=\"partner\"\n                           [searchText]=\"searchText\"\n                           (refresh)=\"emitRefresh()\">\n    </kan-partner-list-item>\n</div>\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/modules/admin/components/partner/list/component.html
// module id = ./src/modules/admin/components/partner/list/component.html
// module chunks = main